var $4ce06844b60c40b5$exports = {};
$4ce06844b60c40b5$exports = {
    "help": `Pomo\u{10D}`,
    "info": `Informacije`
};


export {$4ce06844b60c40b5$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
